import { createContext, useContext } from 'react';

export interface RegisteredTour {
  /** Stable id (the variant's tourId). Re-registering the same id replaces it. */
  id: string;
  /**
   * Translated, user-facing name. Shown in the header's tour menu when several
   * tours are registered for the current route, so the user knows which flow
   * they're starting; also used as the trigger's accessible label.
   */
  label: string;
  start: () => void;
}

interface TourContextValue {
  /** Tours available on the current route, in registration order. */
  tours: RegisteredTour[];
  /** Registers a tour for the current route. Returns an unregister function. */
  registerTour: (tour: RegisteredTour) => () => void;
}

export const TourContext = createContext<TourContextValue>({
  tours: [],
  registerTour: () => () => {},
});

export function useTourContext() {
  return useContext(TourContext);
}
